import HELPER from '@/app/utils/HELPER';
import store from '@/app/store/store';
import atom from '@/app/editor/iframe/atom';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import storeX, { app } from '@/store';
import { SPACING_DATA_KEY } from '@modules/editor-sidebar';
import emitter from '@/emitter';
import { addElement, editElement, removeElement, isLandingPage } from '@/modules/gem-meter';
import GemMeterHelper from '@/modules/gem-meter/GemMeterEngine/Engine/v2/GemMeterHelper';
import { isInIframe } from '@/app/utils/helpers';

(function (jQuery) {
  jQuery.gfHistory = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    const _undo = [];
    let _redo = [];
    let _item;
    let _loading = false;
    let _countAddUndo = 0;

    let _merOldSettings = [];
    // color picker, input field --> change many times
    let _merOldBackupSettings = [];

    let _merOldDesignOptions;
    let _merOldBackupDesignOptions;

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $gfResTool = jQuery('#gfResTool');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);

      $element.on('tab-change', function (event, tabModule) {
        const history = _this.getLastHistory();
        if (history.action != 'tabs') {
          const $activeTab = jQuery(tabModule).children('ul').children('li.gf_tab.gf_tab-active');
          const tabIndex = parseInt($activeTab.attr('data-index')) - 1;

          const merId = jQuery(tabModule).parent().attr('id');

          const extra = tabIndex;
          _this.addHistory('tabs', merId, extra);
        }
      });

      $element.on('history', function (event, json) {
        _this.addHistory(json.action, undefined, json);
      });

      // Lắng nghe sự kiện reload and leave editor
      if (isInIframe()) {
        window.onbeforeunload = null;
      } else {
        window.onbeforeunload = function () {
          const presetIsEdited = app.$store.getters['sidebar/PRESET_IS_EDITED'];
          if (!store.getValue('__isSaved') || presetIsEdited) {
            return 'Are you sure you want to leave?';
          }

          return;
        };
      }

      _this.applyEvents();
      return false;
    };

    // gfHistory.applyEvents
    this.applyEvents = function () {
      $divTopBar.find('.gf_history-item').on('mousedown.undoandredo', function () {
        const $that = $(this);

        if ($that.attr('disabled')) {
          return;
        }

        if (!_loading && !$that.hasClass('lock')) {
          const action = $that.attr('data-action');
          // Add to gfCount
          const extraCount = {
            value: action,
          };
          if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
            $gryffEditor.data('gfcount').add('undo-redo', extraCount);
          }

          function runUndoRedo() {
            // Loading
            _loading = true;
            $that.addClass('loading');
            const cacheHtmlButton = $that.html();
            $that.html('<span></span>');
            try {
              function doneUndoRedo($that) {
                setTimeout(function () {
                  _loading = false;
                  $that.html(cacheHtmlButton);
                  $that.removeClass('loading');

                  // Update scroll
                  _this.updateScroll();
                }, 300);
              }
              jQuery.when(_this.processUndoRedo($that)).done(doneUndoRedo($that));
            } catch (error) {
              console.log(error);
              _loading = false;
              $that.html(cacheHtmlButton);
              $that.removeClass('loading');
            } finally {
              store.setValue('__isSaved', false);
            }
          }
          if (window._isHistoryEditing) {
            setTimeout(function () {
              runUndoRedo();
            }, 100);
          } else {
            runUndoRedo();
          }
        }
      });
    };
    //Process when undo/redo buttons clicked
    this.processUndoRedo = function ($that) {
      const action = $that.attr('data-action');
      let item;
      //Get undo or redo object, assign to item
      switch (action) {
        case 'undo':
          if (_undo.length > 0) {
            item = _undo.pop();

            // loại bỏ undo của move bị hỏng.
            while (true) {
              if (item && item.action == 'move') {
                if (item.events.length < 2) {
                  item = _undo.pop();
                } else {
                  break;
                }
              } else {
                break;
              }
            }

            if (item && item.action == 'tabs') {
              var lastItem = _this.getLastHistory();
              if (!jQuery.isEmptyObject(lastItem)) {
                var $tabs = $gryffBody.find('#' + item.id);
                var moduleId = $tabs.data('gfmodule').getModuleId();
                var moduleIdSlug = moduleId.toString().replace(/-/g, '');
                var func = 'getTab' + moduleIdSlug;

                if (document.getElementById('gfFrame').contentWindow[func]) {
                  var html = document.getElementById('gfFrame').contentWindow[func]().getDetachesHtml();
                  var $html = jQuery('<div />').html(html[item.index]);

                  var found = false;
                  if (lastItem.action == 'move') {
                    if (
                      lastItem.events[0].position.inside != '' &&
                      $html.find('#' + lastItem.events[0].position.inside).length > 0
                    ) {
                      found = true;
                    } else if (
                      lastItem.events[1].position.inside != '' &&
                      $html.find('#' + lastItem.events[1].position.inside).length > 0
                    ) {
                      found = true;
                    } else if (
                      lastItem.events[0].position.inside == item.id ||
                      lastItem.events[1].position.inside == item.id
                    ) {
                      found = true;
                    }
                  } else if (
                    lastItem.action == 'setting' ||
                    lastItem.action == 'design-option' ||
                    lastItem.action == 'repeator'
                  ) {
                    if (lastItem.id != '' && $html.find('#' + lastItem.id).length > 0) {
                      found = true;
                    }
                  } else {
                    if (
                      lastItem.position &&
                      lastItem.position.inside != '' &&
                      $html.find('#' + lastItem.position.inside).length > 0
                    ) {
                      found = true;
                    } else if (lastItem.position && lastItem.position.inside == item.id) {
                      found = true;
                    }
                  }
                  if (found) {
                    // Add to redo item tab;
                    var indexLastTab = parseInt($tabs.find('li.gf_tab-active').attr('data-index')) - 1;
                    var itemTab = {
                      action: item.action,
                      id: item.id,
                      index: indexLastTab,
                    };
                    _redo.push(itemTab);

                    document.getElementById('gfFrame').contentWindow[func]().gotoTabWithIndex(item.index);
                  }
                }
              }
              // pop tabs
              item = _undo.pop();
            }
          }

          break;

        case 'redo':
          item = _redo.pop();
          if (_redo.length > 0) {
            if (item && item.action == 'tabs') {
              var lastItem = _this.getLastRedo();
              if (!jQuery.isEmptyObject(lastItem)) {
                var $tabs = $gryffBody.find('#' + item.id);
                var moduleId = $tabs.data('gfmodule').getModuleId();
                var moduleIdSlug = moduleId.toString().replace(/-/g, '');
                var func = 'getTab' + moduleIdSlug;

                if (document.getElementById('gfFrame').contentWindow[func]) {
                  var html = document.getElementById('gfFrame').contentWindow[func]().getDetachesHtml();
                  var $html = jQuery('<div />').html(html[item.index]);

                  var found = false;
                  if (lastItem.action == 'move') {
                    if (
                      lastItem.events[0].position.inside != '' &&
                      $html.find('#' + lastItem.events[0].position.inside).length > 0
                    ) {
                      found = true;
                    } else if (
                      lastItem.events[1].position.inside != '' &&
                      $html.find('#' + lastItem.events[1].position.inside).length > 0
                    ) {
                      found = true;
                    } else if (
                      lastItem.events[0].position.inside == item.id ||
                      lastItem.events[1].position.inside == item.id
                    ) {
                      found = true;
                    }
                  } else if (
                    lastItem.action == 'setting' ||
                    lastItem.action == 'design-option' ||
                    lastItem.action == 'repeator'
                  ) {
                    if (lastItem.id != '' && $html.find('#' + lastItem.id).length > 0) {
                      found = true;
                    }
                  } else {
                    if (lastItem.position.inside != '' && $html.find('#' + lastItem.position.inside).length > 0) {
                      found = true;
                    } else if (lastItem.position.inside == item.id) {
                      found = true;
                    }
                  }
                  if (found) {
                    // Add to redo item tab;
                    var indexLastTab = parseInt($tabs.find('li.gf_tab-active').attr('data-index')) - 1;
                    var itemTab = {
                      action: item.action,
                      id: item.id,
                      index: indexLastTab,
                    };
                    _undo.push(itemTab);

                    document.getElementById('gfFrame').contentWindow[func]().gotoTabWithIndex(item.index);
                  }
                }
              }
              // pop tabs
              item = _redo.pop();
            }
          }
          break;
      }
      if (item != undefined) {
        const blockAction = item.action;

        _item = item;

        const $mer = $gryffBody.find('#' + item.id);
        const dataSetting = storeX.state.editor.dataSettings;
        _this.addRedoAndUndo(action, item, $mer);
        const elementById = JSON.parse(dataSetting[item.id.substring(2)] || '{}');

        switch (blockAction) {
          case 'column-chooser':
            // Change screen size to expected size
            var screenType = action == 'undo' ? item.extra.oldScreen : item.extra.newScreen;
            if ($gfResTool.data('gfrestool') && $gfResTool.data('gfrestool').getCurrentStatus() != screenType) {
              $gfResTool.data('gfrestool').resizeScreen(screenType);
              $gfResTool.data('gfrestool').setCurrentStatus(screenType);
              jQuery('#gfResTool .select-screen-inner .' + screenType).trigger('click'); //Change screen sign to desktop
            }

            var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            if ($mdSettings.length > 0 && $mdSettings.data('edittingID') == item.id) {
              if (!$mdSettings.find('.settings-panel').hasClass('active')) {
                if ($mdSettings.find('.simple-tabs').data('gftabs')) {
                  $mdSettings.find('.simple-tabs').data('gftabs').gotoTab(0);
                }
              }
            } else {
              var capture = false;
              if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').openElementSettings(undefined, undefined, capture);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').openModuleSettings(undefined, undefined, capture);
              } else if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').openRowSettings(undefined, undefined, capture);
              }

              // settings already opended
              setTimeout(function () {
                $mdSettings = $gfLeftSideBar.find('#md-settings.active');
              }, 5);
            }
            //Re-arrange elements
            setTimeout(function () {
              //Read previous layout
              let rowLayout;
              if (action == 'undo') rowLayout = item.extra.oldRowLayout;
              else rowLayout = item.extra.newRowLayout;

              const desktopRowLayout = rowLayout[0];
              const laptopRowLayout = rowLayout[1];
              const tabletRowLayout = rowLayout[2];
              const mobileRowLayout = rowLayout[3];

              $gfLeftSideBar
                .find('#gf_row-layout-md')
                .val(laptopRowLayout)
                .attr('value', laptopRowLayout)
                .trigger('input-change');
              $gfLeftSideBar
                .find('#gf_row-layout-sm')
                .val(tabletRowLayout)
                .attr('value', tabletRowLayout)
                .trigger('input-change');
              $gfLeftSideBar
                .find('#gf_row-layout-xs')
                .val(mobileRowLayout)
                .attr('value', mobileRowLayout)
                .trigger('input-change');
              $gfLeftSideBar
                .find('#gf_row-layout')
                .val(desktopRowLayout)
                .attr('value', desktopRowLayout)
                .trigger('undo-redo-update');

              if (action == 'undo' && item.extra.rowSettings) {
                const $targetRow = $gryffBody.find('#r-' + item.id);

                if ($targetRow.length > 0) {
                  $targetRow.children('.gf_column').each(function () {
                    const $column = jQuery(this);
                    const index = $column.index();

                    $column.children('div').each(function () {
                      const $mer = jQuery(this);
                      if ($mer.hasClass('gf_row') || $mer.hasClass('module-wrap') || $mer.hasClass('element-wrap')) {
                        const merId = $mer.attr('id');

                        let foundIndex = -1;
                        for (let k = 0; k < item.extra.rowSettings.length; k++) {
                          if (item.extra.rowSettings[k].id == merId) {
                            foundIndex = item.extra.rowSettings[k].index;
                            break;
                          }
                        }

                        if (foundIndex != index && foundIndex != undefined && foundIndex != -1) {
                          const $detachMER = $mer.detach();

                          const $gfAddContent = $targetRow
                            .children('.gf_column')
                            .eq(foundIndex)
                            .children('.gf_add-content');
                          if ($gfAddContent.length > 0) {
                            $gfAddContent.before($detachMER);
                          }
                        }
                      }
                    });
                  });
                }
              }
            }, 10);

            break;
          case 'add':
            if ($mer.length > 0) {
              var isGotoTab0 = undefined;
              var historyFlag = false;

              if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').doRemoveMe(undefined, historyFlag);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').doRemoveMe(undefined, historyFlag);
              } else if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').doRemoveMe(undefined, historyFlag);
              }
            }
            break;

          case 'delete':
            var html = item.data.html;
            var bkHtml = item.data.bkHtml;

            if (jQuery.trim(item.position.after) == '') {
              if (jQuery.trim(item.position.inside) == '') {
                var $container = $gryffEditor;
                if ($mer.attr('data-label') == 'Popup') {
                  $container = $gryffBody;
                }
              } else {
                var $container = $gryffBody.find('#' + item.position.inside);
                let index = parseInt(item.position.index);

                if ($container.hasClass('gf_row')) {
                  index = index - 1;
                  $container = $container.children('.gf_column').eq(index);
                } else {
                  if (item.position.key != 'content') {
                    var elementTag = '.item-content[data-index="' + index + '"][data-key="' + item.position.key + '"]';
                  } else {
                    var elementTag = '.item-content[data-index="' + index + '"]';
                  }

                  $container.find(elementTag).each(function () {
                    const $module = jQuery(this).closest('.gf_row, .module-wrap, .element-wrap');
                    if ($module.attr('id') == item.position.inside) {
                      $container = jQuery(this);
                    }
                  });
                }
              }

              if ($mer.attr('data-label') == 'Popup') {
                $container.append(html);
              } else {
                $container.prepend(html);
              }

              HELPER.addContentBk(bkHtml);

              const $firstChild = $container.children('.gf_row, .module-wrap, .element-wrap').first();

              if ($firstChild.hasClass('gf_row')) {
                // $firstChild.gfRow().css('display', 'block');
                atom.Init($firstChild);
                $firstChild.css('display', 'block');
              } else if ($firstChild.hasClass('module-wrap')) {
                if ($firstChild.attr('data-label') == 'Popup') {
                  // $firstChild.gfModule();
                  atom.Init($firstChild);
                  $firstChild.trigger('gempage.showpopup');
                } else {
                  // $firstChild.gfModule().css('display', 'block');
                  atom.Init($firstChild);
                  $firstChild.css('display', 'block');
                }
              } else if ($firstChild.hasClass('element-wrap')) {
                // $firstChild.gfElement().css('display', 'block');
                atom.Init($firstChild);
                $firstChild.css('display', 'block');
              }

              // detect element or module change
              HELPER.flagListItemChange($firstChild, 'new');

              var $itemContent = $firstChild.closest('.item-content');
              HELPER.detectContentChange($itemContent);
            } else {
              const $before = $gryffBody.find('#' + item.position.after);
              $before.after(html);
              HELPER.addContentBk(bkHtml);

              let $merChild;
              if ($before.next('.gf_row').length > 0) {
                $merChild = $before.next('.gf_row');
                // $merChild.gfRow().css('display', 'block');
                atom.Init($merChild);
                $merChild.css('display', 'block');
              } else if ($before.next('.module-wrap').length > 0) {
                $merChild = $before.next('.module-wrap');
                // $merChild.gfModule().css('display', 'block');
                atom.Init($merChild);
                $merChild.css('display', 'block');
              } else if ($before.next('.element-wrap').length > 0) {
                $merChild = $before.next('.element-wrap');
                // $merChild.gfElement().css('display', 'block');
                atom.Init($merChild);
                $merChild.css('display', 'block');
              }

              // detect element or module change
              HELPER.flagListItemChange($merChild, 'new');

              var $itemContent = $before.closest('.item-content');
              HELPER.detectContentChange($itemContent);
            }
            break;

          case 'move':
            // TO
            // Remove if inside the list
            var $itemContentTo;
            if (item.events[1] != undefined && item.events[1].newId != '') {
              const $childElement = $gryffBody.find('#' + item.events[1].newId);
              $itemContentTo = $childElement.closest('.item-content');

              if ($childElement.length > 0) {
                if (HELPER.isInsideTheList($childElement)) {
                  HELPER.flagListItemChange($childElement, 'delete');
                } else {
                  var isGotoTab0 = false;
                  var historyFlag = false;

                  if ($childElement.data('gfrow') != undefined) {
                    $childElement.data('gfrow').doRemoveMe(isGotoTab0, historyFlag);
                  } else if ($childElement.data('gfmodule') != undefined) {
                    $childElement.data('gfmodule').doRemoveMe(isGotoTab0, historyFlag);
                  } else if ($childElement.data('gfelement') != undefined) {
                    $childElement.data('gfelement').doRemoveMe(isGotoTab0, historyFlag);
                  }
                }
              }

              HELPER.detectContentChange($itemContentTo);
              window._contentChangeTimeout = null;
            } else {
              if (jQuery.trim(item.events[1].position.inside) != '') {
                $itemContentTo = $mer.closest('.item-content');
              }
              var $moveMer = $mer.detach();
            }

            setTimeout(function () {
              // FROM
              let $itemContentFrom;
              if (jQuery.trim(item.events[0].position.after) == '') {
                if (jQuery.trim(item.events[0].position.inside) == '') {
                  var $container = $gryffEditor;

                  if ($mer.attr('data-label') == 'Popup') {
                    $container = $gryffBody;
                  }
                } else {
                  var $container = $gryffBody.find('#' + item.events[0].position.inside);
                  let index = parseInt(item.events[0].position.index);

                  if ($container.hasClass('gf_row')) {
                    index = index - 1;
                    $container = $container.children('.gf_column').eq(index);
                  } else {
                    if (item.events[0].position.key != 'content') {
                      var elementTag =
                        '.item-content[data-index="' + index + '"][data-key="' + item.events[0].position.key + '"]';
                    } else {
                      var elementTag = '.item-content[data-index="' + index + '"]';
                    }

                    $container.find(elementTag).each(function () {
                      const $module = jQuery(this).closest('.gf_row, .module-wrap, .element-wrap');
                      if ($module.attr('id') == item.events[0].position.inside) {
                        $container = jQuery(this);
                      }
                    });
                  }
                }
                if (item.events[1] != undefined && item.events[1].newId != '') {
                  if ($mer.attr('data-label') == 'Popup') {
                    $container.append(item.events[1].data.html);
                  } else {
                    $container.prepend(item.events[1].data.html);
                  }

                  HELPER.addContentBk(item.events[1].data.bkHtml);

                  var $firstChild = $container.children('.gf_row, .module-wrap, .element-wrap').first();

                  if ($firstChild.hasClass('gf_row')) {
                    // $firstChild.gfRow().css('display', 'block');
                    atom.Init($firstChild);
                    $firstChild.css('display', 'block');
                  } else if ($firstChild.hasClass('module-wrap')) {
                    // $firstChild.gfModule().css('display', 'block');
                    atom.Init($firstChild);
                    $firstChild.css('display', 'block');
                  } else if ($firstChild.hasClass('element-wrap')) {
                    // $firstChild.gfElement().css('display', 'block');
                    atom.Init($firstChild);
                    $firstChild.css('display', 'block');
                  }

                  if (HELPER.isInsideTheList($firstChild)) {
                    HELPER.flagListItemChange($firstChild, 'new');
                  }
                  $itemContentFrom = $firstChild.closest('.item-content');
                  HELPER.detectContentChange($itemContentFrom);
                  window._contentChangeTimeout = null;
                } else {
                  $container.prepend($moveMer);
                  $itemContentFrom = $moveMer.closest('.item-content');
                }
              } else {
                const $before = $gryffBody.find('#' + item.events[0].position.after);

                if (item.events[1] != undefined && item.events[1].newId != '') {
                  $before.after(item.events[1].data.html);
                  HELPER.addContentBk(item.events[1].data.bkHtml);

                  var $firstChild = $before.next();

                  if ($firstChild.hasClass('gf_row')) {
                    // $firstChild.gfRow().css('display', 'block');
                    atom.Init($firstChild);
                    $firstChild.css('display', 'block');
                  } else if ($firstChild.hasClass('module-wrap')) {
                    // $firstChild.gfModule().css('display', 'block');
                    atom.Init($firstChild);
                    $firstChild.css('display', 'block');
                  } else if ($firstChild.hasClass('element-wrap')) {
                    // $firstChild.gfElement().css('display', 'block');
                    atom.Init($firstChild);
                    $firstChild.css('display', 'block');
                  }

                  if (HELPER.isInsideTheList($firstChild)) {
                    HELPER.flagListItemChange($firstChild, 'new');
                  }
                  $itemContentFrom = $firstChild.closest('.item-content');
                  HELPER.detectContentChange($itemContentFrom);
                  window._contentChangeTimeout = null;
                } else {
                  $before.after($moveMer);
                  $itemContentFrom = $moveMer.closest('.item-content');
                }
              }

              // detectContentChange FROM AND TO
              if (item.events[1].position.inside != '' && item.events[1].newId == '') {
                HELPER.detectContentChange($itemContentTo);
                window._contentChangeTimeout = null;
              }
              if (item.events[0].position.inside != '' && item.events[1].newId == '') {
                HELPER.detectContentChange($itemContentFrom);
                window._contentChangeTimeout = null;
              }
            }, 300);
            break;

          case 'setting':
            // settings already opended
            var screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
            if (screenType != item.screenType) {
              $gfResTool.data('gfrestool').resizeScreen(item.screenType);
            }

            var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            if ($mdSettings.length > 0 && $mdSettings.data('edittingID') == item.id) {
              if (!$mdSettings.find('.settings-panel').hasClass('active')) {
                if ($mdSettings.find('.simple-tabs').data('gftabs')) {
                  $mdSettings.find('.simple-tabs').data('gftabs').gotoTab(0);
                }
              }
            } else {
              var capture = false;
              if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').openElementSettings(undefined, undefined, capture);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').openModuleSettings(undefined, undefined, capture);
              } else if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').openRowSettings(undefined, undefined, capture);
              }

              // settings already opended
              setTimeout(function () {
                $mdSettings = $gfLeftSideBar.find('#md-settings.active');
              }, 5);
            }

            setTimeout(function () {
              for (let i = 0; i < item.options.length; i++) {
                const option = item.options[i];

                const $field = $mdSettings.find('[name="' + option.name + '"]');
                if ($field.length > 0) {
                  if ($field.attr('value') != option.value) {
                    $field
                      .attr('value', option.value)
                      .val(option.value)
                      .trigger('value-change')
                      .trigger('input-change');
                  }

                  if (i == item.options.length - 1) {
                    if (checkKeyValid('atomHistory')) {
                      $field.trigger('history-input-change');
                    }
                    $field.trigger('input-change');
                    _this.captureMERSettings();

                    // cap nhat lai vi tri cua elemen tren column cu truoc khi undo
                    if (item.extra.rowSettings) {
                      var $targetRow = $gryffBody.find('#' + item.id);
                      if ($targetRow.length > 0) {
                        $targetRow.children('.gf_column').each(function () {
                          const $column = jQuery(this);
                          const index = $column.index();

                          $column.children('div').each(function () {
                            const $mer = jQuery(this);
                            if (
                              $mer.hasClass('gf_row') ||
                              $mer.hasClass('module-wrap') ||
                              $mer.hasClass('element-wrap')
                            ) {
                              const merId = $mer.attr('id');

                              let foundIndex = -1;
                              for (let k = 0; k < item.extra.rowSettings.length; k++) {
                                if (item.extra.rowSettings[k].id == merId) {
                                  foundIndex = item.extra.rowSettings[k].index;
                                  break;
                                }
                              }

                              if (foundIndex != index && foundIndex != undefined && foundIndex != -1) {
                                const $detachMER = $mer.detach();

                                const $gfAddContent = $targetRow
                                  .children('.gf_column')
                                  .eq(foundIndex)
                                  .children('.gf_add-content');
                                if ($gfAddContent.length > 0) {
                                  $gfAddContent.before($detachMER);
                                }
                              }
                            }
                          });
                        });
                      }
                    }

                    // cap nhat lai vi tri cua column
                    if (item.extra.rowSwaps) {
                      var $targetRow = $gryffBody.find('#' + item.id);
                      if ($targetRow.length > 0) {
                        var historyOrders = [];

                        var minIndex = 0;
                        const min = 0;

                        var getMin2HistoryOrders = function (array, min) {
                          if (historyOrders.length == array.length) {
                            return false;
                          }

                          for (let r = 0; r < array.length; r++) {
                            if (min == array[r]) {
                              minIndex = r;
                              break;
                            }
                          }
                          const $minColumn = $targetRow.children('.gf_column').eq(minIndex);
                          historyOrders.push($minColumn.attr('id'));

                          min++;
                          getMin2HistoryOrders(array, min);
                        };
                        getMin2HistoryOrders(item.extra.rowSwaps, min);

                        if ($targetRow.children('.gf_column').length > historyOrders.length) {
                          $targetRow.children('.gf_column').each(function () {
                            let found = false;
                            for (let k = 0; k < historyOrders.length; k++) {
                              if (jQuery(this).attr('id') == historyOrders[k]) {
                                found = true;
                              }
                            }
                            if (!found) {
                              jQuery(this).remove();
                            }
                          });
                        }

                        if ($targetRow.children('.gf_column').length < historyOrders.length) {
                          $mdSettings.find('.gf_row-layout').data('gfcolumnchooser').columnManager();
                        }
                        const $placeholder = jQuery('<div />');
                        $targetRow.children('.gf_column:last').after($placeholder);
                        for (var h = 0; h < historyOrders.length; h++) {
                          var $column = $targetRow.find('#' + historyOrders[h]).detach();
                          $placeholder.before($column);
                        }
                        $placeholder.remove();

                        if ($mdSettings.find('.gf_row-layout').data('gfcolumnchooser') != undefined) {
                          $mdSettings.find('.gf_row-layout').data('gfcolumnchooser').columnManager();
                        }

                        // to update placeholder
                        setTimeout(function () {
                          $gryffEditor.data('gryffeditor').updatePlaceHolders();
                        }, 0);

                        // detect element or module change
                        var $itemContent = $targetRow.closest('.item-content');
                        HELPER.detectContentChange($itemContent);
                      }
                    }

                    if (item.extra.columnDeleted) {
                      const data = item.extra.columnDeleted.data;

                      var $targetRow = $gryffBody.find('#' + item.id);
                      if ($targetRow.length > 0) {
                        var oldArray = item.extra.columnDeleted.oldArray;
                        const columnLength = $targetRow.children('.gf_column').length;

                        // Nếu số lượng cột bằng số lượng đang backup thì xóa bỏ cột cuối cùng.
                        if (columnLength >= oldArray.length) {
                          var $column = $targetRow.children('.gf_column').eq(columnLength - 1);
                          $column.remove();
                        }

                        for (var h = 0; h < oldArray.length; h++) {
                          if (oldArray[h] == -1) {
                            if (h == 0) {
                              $targetRow.children('.gf_column').eq(0).before(data.html);
                              var $column = $targetRow.children('.gf_column').eq(0);
                            } else {
                              const colIndex = h - 1;
                              const $beforeColumn = $targetRow.children('.gf_column').eq(colIndex);

                              $beforeColumn.after(data.html);
                              var $column = $beforeColumn.next();
                            }
                          }
                        }

                        HELPER.addContentBk(data.bkHtml);
                        $column.children('.gf_row, .module-wrap, .element-wrap').each(function () {
                          const $mer = jQuery(this);
                          if ($mer.hasClass('gf_row')) {
                            // $mer.gfRow().css('display', 'block');
                            atom.Init($mer);
                            $mer.css('display', 'block');
                          } else if ($mer.hasClass('module-wrap')) {
                            // $mer.gfModule().css('display', 'block');
                            atom.Init($mer);
                            $mer.css('display', 'block');
                          } else if ($mer.hasClass('element-wrap')) {
                            // $mer.gfElement().css('display', 'block');
                            atom.Init($mer);
                            $mer.css('display', 'block');
                          }
                        });

                        if ($mdSettings.find('.gf_row-layout').data('gfcolumnchooser') != undefined) {
                          $mdSettings.find('.gf_row-layout').data('gfcolumnchooser').columnManager();
                        }

                        // detect element or module change
                        var $itemContent = $targetRow.closest('.item-content');
                        HELPER.detectContentChange($itemContent);
                      }
                    }

                    if (item.extra.columnRestored) {
                      var oldArray = item.extra.columnRestored.oldArray;
                      var $targetRow = $gryffBody.find('#' + item.id);
                      let index = 0;
                      for (var h = 0; h < oldArray.length; h++) {
                        if (oldArray[h] == -1) {
                          index = h;
                        }
                      }
                      const $activeColumn = $targetRow.children('.gf_column').eq(index);
                      const isGotoTab0 = false;
                      $targetRow.data('gfrow').removeAllChilds($activeColumn, 'column', isGotoTab0);

                      if ($mdSettings.find('.gf_row-layout').data('gfcolumnchooser') != undefined) {
                        $mdSettings.find('.gf_row-layout').data('gfcolumnchooser').columnManager();
                      }

                      // detect element or module change
                      var $itemContent = $targetRow.closest('.item-content');
                      HELPER.detectContentChange($itemContent);
                    }
                  }
                }
              }
            }, 10);
            break;

          case 'field-setting':
            // settings already opended
            var screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
            if (screenType != item.screenType) {
              $gfResTool.data('gfrestool').resizeScreen(item.screenType);
            }
            var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            if ($mdSettings.length > 0 && $mdSettings.data('edittingID') == item.id) {
              if (!$mdSettings.find('.settings-panel').hasClass('active')) {
                if ($mdSettings.find('.simple-tabs').data('gftabs')) {
                  $mdSettings.find('.simple-tabs').data('gftabs').gotoTab(0);
                }
              }
            } else {
              var capture = false;
              if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').openElementSettings(undefined, undefined, capture);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').openModuleSettings(undefined, undefined, capture);
              } else if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').openRowSettings(undefined, undefined, capture);
              }

              // settings already opended
              setTimeout(function () {
                $mdSettings = $gfLeftSideBar.find('#md-settings.active');
              }, 5);
            }

            setTimeout(function () {
              const $field = $mdSettings.find('[name="' + item.extra.name + '"]');
              if ($field.attr('value') != item.extra.value) {
                $field
                  .attr('value', item.extra.value)
                  .val(item.extra.value)
                  .trigger('value-change')
                  .trigger('input-change');
                _this.captureMERSettings();
              }
            }, 10);

            break;
          case 'design-option':
            var screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
            if (screenType != item.screenType) {
              $gfResTool.data('gfrestool').resizeScreen(item.screenType);
            }

            var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            if ($mdSettings.length > 0 && $mdSettings.data('edittingID') == item.id) {
              if (!$mdSettings.find('.design-panel').hasClass('active')) {
                if ($mdSettings.find('.simple-tabs').data('gftabs')) {
                  $mdSettings.find('.simple-tabs').data('gftabs').gotoTab(1);
                }
              }
            } else {
              var capture = false;
              if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').openElementSettings('Design', undefined, capture);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').openModuleSettings('Design', undefined, capture);
              } else if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').openRowSettings('Design', undefined, capture);
              }

              // settings already opended
              setTimeout(function () {
                $mdSettings = $gfLeftSideBar.find('#md-settings.active');
              }, 5);
            }

            setTimeout(function () {
              if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').runStyle(item.style);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').runStyle(item.style);
              } else if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').runStyle(item.style);
              }
            }, 10);

            setTimeout(function () {
              if ($mdSettings.find('.simple-tabs').data('gftabs')) {
                $mdSettings.find('.simple-tabs').data('gftabs').getDesignOptions();
              }
              // aaaaaaaaaaa
              if ($mer.data('gfoutline')) {
                $mer.data('gfoutline').updatePadding('top');
                $mer.data('gfoutline').updatePadding('left');
                $mer.data('gfoutline').updatePadding('bottom');
                $mer.data('gfoutline').updatePadding('right');
              }
              _this.captureMERSettings();
            }, 100);

            break;

          case 'repeator':
            var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            if ($mdSettings.length > 0 && $mdSettings.data('edittingID') == item.id) {
              if (!$mdSettings.find('.settings-panel').hasClass('active')) {
                if ($mdSettings.find('.simple-tabs').data('gftabs')) {
                  $mdSettings.find('.simple-tabs').data('gftabs').gotoTab(0);
                }
              }
            } else {
              var capture = false;
              if ($mer.data('gfelement') != undefined) {
                $mer.data('gfelement').openElementSettings(undefined, undefined, capture);
              } else if ($mer.data('gfmodule') != undefined) {
                $mer.data('gfmodule').openModuleSettings(undefined, undefined, capture);
              } else if ($mer.data('gfrow') != undefined) {
                $mer.data('gfrow').openRowSettings(undefined, undefined, capture);
              }

              // settings already opended
              setTimeout(function () {
                $mdSettings = $gfLeftSideBar.find('#md-settings.active');
              }, 5);
            }

            setTimeout(function () {
              if ($mer.length > 0) {
                if ($mer.data('gfmodule') != undefined) {
                  if ($mer.attr('data-label') != '(P) Swatches') {
                    const jsonHtml = $mer.data('gfmodule').getModuleData();
                    var currentData = jQuery.parseJSON(jsonHtml);
                    var currentItems = currentData.items;

                    var itemData = jQuery.parseJSON(item.extra.items);
                    var items = itemData.items;

                    // clone item
                    if (currentItems.length > items.length) {
                      var diff = [];

                      for (var k = 0; k < currentItems.length; k++) {
                        var found = false;
                        for (var q = 0; q < items.length; q++) {
                          if (currentItems[k].id == items[q].id) {
                            found = true;
                            break;
                          }
                        }
                        if (!found) {
                          diff.push(currentItems[k]);
                        }
                      }

                      var isGotoTab0 = false;
                      var historyFlag = false;

                      for (var k = 0; k < diff.length; k++) {
                        var $html = jQuery('<div />').html(diff[k].content);

                        $html.children('div').each(function () {
                          const merChildId = jQuery(this).attr('id');
                          const $merChild = $mer.find('#' + merChildId);

                          if ($merChild.data('gfrow') != undefined) {
                            $merChild.data('gfrow').doRemoveMe(isGotoTab0, historyFlag);
                          } else if ($merChild.data('gfmodule') != undefined) {
                            $merChild.data('gfmodule').doRemoveMe(isGotoTab0, historyFlag);
                          } else if ($merChild.data('gfelement') != undefined) {
                            $merChild.data('gfelement').doRemoveMe(isGotoTab0, historyFlag);
                          }
                        });
                      }

                      // delete item
                    } else if (currentItems.length < items.length) {
                      var childData = item.extra.childData;
                      HELPER.addContentBk(childData.bkHtml);

                      // swap item
                    } else {
                      // cap nhat lai data ben duoi
                    }
                  }

                  // REFRESH
                  if ($mer.attr('data-label') != '(P) Swatches') {
                    const $repeator = $mdSettings.find('.repeator');
                    if ($repeator.data('gfrepeator') != undefined) {
                      $repeator.data('gfrepeator').initWithJson(itemData);
                      $repeator.data('gfrepeator').saveJsonToModule();

                      $mer.data('gfmodule').setModuleData(item.extra.items);
                      $mer.data('gfmodule').refresh();
                    }
                  } else {
                    const $swatcher = $mdSettings.find('#swatcher');
                    if ($swatcher.data('gfswatcher') != undefined) {
                      $swatcher.data('gfswatcher').initWithJson(item.extra.items);
                      $swatcher.data('gfswatcher').saveJsonToModule();
                    }
                  }
                } else if ($mer.data('gfelement') != undefined) {
                  const $divSettings = $mdSettings.children();
                  switch ($divSettings.attr('id')) {
                    case 'md-dropdown':
                      var $dropdown = $divSettings.find('[name="options"]');
                      if ($dropdown && $dropdown.data('gfoptions') != undefined) {
                        var currentData = $dropdown.data('gfoptions').getJsonData();
                        var currentItems = currentData.items;

                        var itemData = jQuery.parseJSON(item.extra.items);
                        var items = itemData.items;

                        // clone item
                        if (currentItems.length > items.length) {
                          var diff = [];

                          for (var k = 0; k < currentItems.length; k++) {
                            var found = false;
                            for (var q = 0; q < items.length; q++) {
                              if (currentItems[k].id == items[q].id) {
                                found = true;
                                break;
                              }
                            }
                            if (!found) {
                              diff.push(currentItems[k]);
                            }
                          }

                          var isGotoTab0 = false;
                          var historyFlag = false;

                          for (var k = 0; k < diff.length; k++) {
                            var $html = jQuery('<div />').html(diff[k].content);

                            $html.children('div').each(function () {
                              const merChildId = jQuery(this).attr('id');
                              const $merChild = $mer.find('#' + merChildId);

                              if ($merChild.data('gfrow') != undefined) {
                                $merChild.data('gfrow').doRemoveMe(isGotoTab0, historyFlag);
                              } else if ($merChild.data('gfmodule') != undefined) {
                                $merChild.data('gfmodule').doRemoveMe(isGotoTab0, historyFlag);
                              } else if ($merChild.data('gfelement') != undefined) {
                                $merChild.data('gfelement').doRemoveMe(isGotoTab0, historyFlag);
                              }
                            });
                          }

                          // delete item
                        } else if (currentItems.length < items.length) {
                          var childData = item.extra.childData;
                          HELPER.addContentBk(childData.bkHtml);

                          // swap item
                        } else {
                          // cap nhat lai data ben duoi
                        }

                        // REFRESH
                        $dropdown.data('gfoptions').saveOption(itemData);
                        $dropdown.data('gfoptions').refresh();
                      }
                      break;
                  }
                }
              }
            }, 10);
            break;

          case 'text-edit':
            if ($mer.length > 0) {
              const $textEdit = $mer.find('.text-edit');
              $textEdit.html(item.html);

              if ($textEdit.hasClass('text-editing')) {
                setTimeout(function () {
                  $gryffEditor.data('gftexteditor').showEditor($mer);
                }, 20);
              }
            } else {
              // không tìm được element text edit;
            }
            break;

          case 'editor':
            if (item.extra) {
              switch (item.extra.edit) {
                case 'code':
                  if (item.extra.style) {
                    var style = item.extra.style;
                    if (item.extra.target != 'col') {
                      if ($mer.data('gfrow') != undefined) {
                        $mer.data('gfrow').setRowCSS(style);
                      } else if ($mer.data('gfmodule') != undefined) {
                        $mer.data('gfmodule').setModuleCSS(style);
                      } else if ($mer.data('gfelement') != undefined) {
                        $mer.data('gfelement').setElementCSS(style);
                      }
                    } else {
                      $mer.data('gfrow').setColCSS(item.extra.colId, style);
                    }
                    // HELPER.flagListItemChange($mer, 'replace');
                    // HELPER.detectContentChange($mer);
                  }
                  if (item.extra.template) {
                    var template = item.extra.template;
                    if ($mer.data('gfmodule') != undefined) {
                      $mer.data('gfmodule').setModuleTemplate(template);
                    } else if ($mer.data('gfelement') != undefined) {
                      $mer.data('gfelement').setElementTemplate(template);
                    }
                    // HELPER.flagListItemChange($mer, 'replace');
                    // HELPER.detectContentChange($mer);
                  }
                  if (item.extra.script) {
                    var script = item.extra.script;
                    if ($mer.data('gfmodule') != undefined) {
                      $mer.data('gfmodule').setModuleScript(script);
                      $mer.data('gfmodule').refresh();
                    }
                    // HELPER.flagListItemChange($mer, 'replace');
                    // HELPER.detectContentChange($mer);
                  }
                  if (item.extra.data) {
                    var data = item.extra.data;
                    if ($mer.data('gfmodule') != undefined) {
                      $mer.data('gfmodule').setModuleData(data);
                    }
                  }
                  HELPER.flagListItemChange($mer, 'replace');
                  HELPER.detectContentChange($mer);
                  break;
                case 'css':
                  var style = item.extra.style;
                  if (item.extra.target != 'col') {
                    if ($mer.data('gfrow') != undefined) {
                      $mer.data('gfrow').setRowCSS(style);
                    } else if ($mer.data('gfmodule') != undefined) {
                      $mer.data('gfmodule').setModuleCSS(style);
                    } else if ($mer.data('gfelement') != undefined) {
                      $mer.data('gfelement').setElementCSS(style);
                    }
                  } else {
                    $mer.data('gfrow').setColCSS(item.extra.colId, style);
                  }

                  HELPER.flagListItemChange($mer, 'replace');
                  HELPER.detectContentChange($mer);
                  break;
                case 'html':
                  var template = item.extra.template;
                  if ($mer.data('gfmodule') != undefined) {
                    $mer.data('gfmodule').setModuleTemplate(template);
                  } else if ($mer.data('gfelement') != undefined) {
                    $mer.data('gfelement').setElementTemplate(template);
                  }

                  HELPER.flagListItemChange($mer, 'replace');
                  HELPER.detectContentChange($mer);
                  break;
                case 'script':
                  var script = item.extra.script;
                  if ($mer.data('gfmodule') != undefined) {
                    $mer.data('gfmodule').setModuleScript(script);
                    $mer.data('gfmodule').refresh();
                  }

                  HELPER.flagListItemChange($mer, 'replace');
                  HELPER.detectContentChange($mer);
                  break;
                case 'data':
                  var data = item.extra.data;
                  if ($mer.data('gfmodule') != undefined) {
                    $mer.data('gfmodule').setModuleData(data);
                  }

                  HELPER.flagListItemChange($mer, 'replace');
                  HELPER.detectContentChange($mer);
                  break;
              }
            }
            break;
        }

        // ===== GemMeter Feature ===== //
        if (isLandingPage()) {
          setTimeout(() => {
            if (
              blockAction === 'setting' ||
              blockAction === 'field-setting' ||
              blockAction === 'design-option' ||
              blockAction === 'text-edit' ||
              blockAction === 'editor' ||
              blockAction === 'repeator'
            ) {
              if (elementById.key) {
                const rules = GemMeterHelper.getRule(elementById.key);
                if (rules) {
                  rules.handlers.forEach((rule) => {
                    editElement(item.id.substring(2), rule.ruleId, true);
                  });
                }
              }
            }
            // On undo add element
            if (blockAction === 'add' && elementById && elementById.key) {
              removeElement(elementById.id);
            }
          }, 100);
        }
        // =========================== //
      }
    };

    this.checkUndoAndRedo = function () {
      if (_undo.length >= 2) {
        $divTopBar.find('.gf_history-item[data-action="undo"]').removeClass('lock').removeClass('disabled');
      } else if (_undo.length == 1) {
        const undoLast = _this.getLastHistory();
        if (undoLast.action == 'tabs') {
          $divTopBar.find('.gf_history-item[data-action="undo"]').addClass('lock').addClass('disabled');
        } else {
          $divTopBar.find('.gf_history-item[data-action="undo"]').removeClass('lock').removeClass('disabled');
        }
      } else {
        $divTopBar.find('.gf_history-item[data-action="undo"]').addClass('lock').addClass('disabled');
      }

      if (_redo.length >= 2) {
        $divTopBar.find('.gf_history-item[data-action="redo"]').removeClass('lock').removeClass('disabled');
      } else if (_redo.length == 1) {
        const redoLast = _this.getLastRedo();
        if (redoLast.action == 'tabs') {
          $divTopBar.find('.gf_history-item[data-action="redo"]').addClass('lock').addClass('disabled');
        } else {
          $divTopBar.find('.gf_history-item[data-action="redo"]').removeClass('lock').removeClass('disabled');
        }
      } else {
        $divTopBar.find('.gf_history-item[data-action="redo"]').addClass('lock').addClass('disabled');
      }
    };

    //Exchange object between undo and redo
    this.addRedoAndUndo = function (type, item, $targetElement) {
      let history = {};
      switch (item.action) {
        case 'column-chooser':
          if (type == 'undo') _redo.push(item);
          else _undo.push(item);

          break;
        case 'add':
          if ($targetElement && $gryffBody.find('#' + $targetElement.attr('id')).length > 0) {
            var data = {};
            if ($targetElement.data('gfrow') != undefined) {
              data = $targetElement.data('gfrow').export('clone');
            } else if ($targetElement.data('gfmodule') != undefined) {
              data = $targetElement.data('gfmodule').export('clone');
            } else if ($targetElement.data('gfelement') != undefined) {
              data = $targetElement.data('gfelement').export('clone');
            }

            if (!jQuery.isEmptyObject(data)) {
              history = {
                id: item.id,
                action: 'delete',
                position: {
                  inside: item.position.inside,
                  after: item.position.after,
                  index: item.position.index,
                  key: item.position.key,
                },
                data: {
                  html: data.html,
                  bkHtml: data.bkHtml,
                },
              };
            }
          }
          break;
        case 'delete':
          history = {
            id: item.id,
            action: 'add',
            position: {
              inside: item.position.inside,
              after: item.position.after,
              index: item.position.index,
              key: item.position.key,
            },
          };
          break;
        case 'move':
          // Khoong phai product list
          if (item.events[1].newId == '') {
            history = {
              id: item.id,
              action: 'move',
              events: [
                {
                  action: 'cut',
                  position: {
                    inside: item.events[1].position.inside,
                    after: item.events[1].position.after,
                    index: item.events[1].position.index,
                    key: item.events[1].position.key,
                  },
                },
                {
                  action: 'paste',
                  position: {
                    inside: item.events[0].position.inside,
                    after: item.events[0].position.after,
                    index: item.events[0].position.index,
                    key: item.events[0].position.key,
                  },
                  newId: '',
                  data: {
                    html: '',
                    bkHtml: '',
                  },
                },
              ],
            };
            // Product List
          } else {
            var data = {};
            // Update targetElement(newId) in product list or editor;
            var $targetElement = $gryffBody.find('#' + item.events[1].newId);
            if ($targetElement.data('gfrow') != undefined) {
              data = $targetElement.data('gfrow').export('clone');
            } else if ($targetElement.data('gfmodule') != undefined) {
              data = $targetElement.data('gfmodule').export('clone');
            } else if ($targetElement.data('gfelement') != undefined) {
              data = $targetElement.data('gfelement').export('clone');
            }
            if (!jQuery.isEmptyObject(data)) {
              const id = item.events[1].newId;
              history = {
                id: id,
                action: 'move',
                events: [
                  {
                    action: 'cut',
                    position: {
                      inside: item.events[1].position.inside,
                      after: item.events[1].position.after,
                      index: item.events[1].position.index,
                      key: item.events[1].position.key,
                    },
                  },
                  {
                    action: 'paste',
                    position: {
                      inside: item.events[0].position.inside,
                      after: item.events[0].position.after,
                      index: item.events[0].position.index,
                      key: item.events[0].position.key,
                    },
                    newId: item.id,
                    data: {
                      html: data.html,
                      bkHtml: data.bkHtml,
                    },
                  },
                ],
              };
            }
          }
          break;
        case 'setting':
          // Open settings
          var capture = false;
          var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
          if ($targetElement && ($mdSettings.length == 0 || $mdSettings.data('edittingID') != item.id)) {
            if ($targetElement.data('gfelement') != undefined) {
              $targetElement.data('gfelement').openElementSettings(undefined, undefined, capture);
            } else if ($targetElement.data('gfmodule') != undefined) {
              $targetElement.data('gfmodule').openModuleSettings(undefined, undefined, capture);
            } else if ($targetElement.data('gfrow') != undefined) {
              $targetElement.data('gfrow').openRowSettings(undefined, undefined, capture);
            }
            setTimeout(function () {
              $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            }, 3);
          }
          setTimeout(function () {
            const screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

            // Advanced settings
            let extra = {};

            if (
              !jQuery.isEmptyObject(item.extra.rowSettings) &&
              !jQuery.isEmptyObject(item.extra.columnDeleted) &&
              !jQuery.isEmptyObject(item.extra.columnRestored) &&
              !jQuery.isEmptyObject(item.extra.rowSwaps)
            ) {
              var options = item.options;
              if (item.extra.rowSettings) {
                // column positions for undo / redo
                extra = {
                  rowSettings: [],
                };
                const $activeRow = $targetElement;
                $activeRow.children('.gf_column').each(function () {
                  const $column = jQuery(this);
                  const index = $column.index();

                  $column.children('div').each(function () {
                    const $mer = jQuery(this);
                    if ($mer.hasClass('gf_row') || $mer.hasClass('module-wrap') || $mer.hasClass('element-wrap')) {
                      const item = {
                        id: $mer.attr('id'),
                        index: index,
                      };
                      extra.rowSettings.push(item);
                    }
                  });
                });
              }
              if (item.extra.columnDeleted) {
                var oldArray = item.extra.columnDeleted.oldArray;
                var data = item.extra.columnDeleted.data;
                extra = {
                  columnRestored: {
                    oldArray: oldArray,
                    data: data,
                  },
                };
              }

              // Redo
              if (item.extra.columnRestored) {
                var data = item.extra.columnRestored.data;
                var oldArray = item.extra.columnRestored.oldArray;
                extra = {
                  columnDeleted: {
                    oldArray: oldArray,
                    data: data,
                  },
                };
              }

              if (item.extra.rowSwaps) {
                const historyOrders = [];
                let minIndex = 0;
                const min = 0;
                var getMin2HistoryOrders = function (array, min) {
                  if (historyOrders.length == array.length) {
                    return false;
                  }

                  for (let r = 0; r < array.length; r++) {
                    if (min == array[r]) {
                      minIndex = r;
                      break;
                    }
                  }
                  historyOrders.push(minIndex);

                  min++;
                  getMin2HistoryOrders(array, min);
                };
                getMin2HistoryOrders(item.extra.rowSwaps, min);
                extra = {
                  rowSwaps: historyOrders,
                };
              }
            } else {
              var options = [];
              // support for gs select button (border corner tab design)
              $mdSettings
                .find('.design-panel')
                .find('input, select, textarea')
                .each(function () {
                  const $this = jQuery(this);
                  if ($this.attr('name') != undefined) {
                    if ($this.attr('before-value')) {
                      $this
                        .attr('value', $this.attr('before-value'))
                        .val($this.attr('before-value'))
                        .trigger('input-change');
                    }
                    const option = {
                      name: $this.attr('name') != undefined ? $this.attr('name') : '',
                      id: $this.attr('id') != undefined ? $this.attr('id') : '',
                      value: $this.attr('value'),
                    };
                    options.push(option);
                  }
                });
              $mdSettings
                .find('.settings-panel, .general-panel')
                .find('input, select, textarea')
                .each(function () {
                  const $this = jQuery(this);
                  if ($this.attr('name') != undefined) {
                    const option = {
                      name: $this.attr('name') != undefined ? $this.attr('name') : '',
                      id: $this.attr('id') != undefined ? $this.attr('id') : '',
                      value: $this.attr('value'),
                    };
                    options.push(option);
                  }
                });
            }

            history = {
              id: item.id,
              action: 'setting',
              options: options,
              screenType: screenType,
              extra: extra,
            };
          }, 5);

          break;
        case 'field-setting':
          // Open settings
          var capture = false;
          var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
          if ($targetElement && ($mdSettings.length == 0 || $mdSettings.data('edittingID') != item.id)) {
            if ($targetElement.data('gfelement') != undefined) {
              $targetElement.data('gfelement').openElementSettings(undefined, undefined, capture);
            } else if ($targetElement.data('gfmodule') != undefined) {
              $targetElement.data('gfmodule').openModuleSettings(undefined, undefined, capture);
            } else if ($targetElement.data('gfrow') != undefined) {
              $targetElement.data('gfrow').openRowSettings(undefined, undefined, capture);
            }
            setTimeout(function () {
              $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            }, 3);
          }
          setTimeout(function () {
            const screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
            const $field = $mdSettings.find('[name="' + item.extra.name + '"]');
            const extra = {
              id: item.extra.id,
              name: item.extra.name,
              screenType: item.extra.screenType,
              value: $field.attr('value'),
            };
            history = {
              id: item.id,
              action: item.action,
              screenType: screenType,
              extra: extra,
            };
          }, 5);
          break;
        case 'design-option':
          // Open settings tab design;
          var capture = false;
          var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
          if ($targetElement && ($mdSettings.length == 0 || $mdSettings.data('edittingID') != item.id)) {
            if ($targetElement.data('gfelement') != undefined) {
              $targetElement.data('gfelement').openElementSettings('Design', undefined, capture);
            } else if ($targetElement.data('gfmodule') != undefined) {
              $targetElement.data('gfmodule').openModuleSettings('Design', undefined, capture);
            } else if ($targetElement.data('gfrow') != undefined) {
              $targetElement.data('gfrow').openRowSettings('Design', undefined, capture);
            }
            setTimeout(function () {
              $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            }, 3);
          }
          setTimeout(function () {
            let style = '';
            if ($targetElement.data('gfelement') != undefined) {
              style = $targetElement.data('gfelement').getElementCSS();
            } else if ($targetElement.data('gfmodule') != undefined) {
              style = $targetElement.data('gfmodule').getModuleCSS();
            } else if ($targetElement.data('gfrow') != undefined) {
              style = $targetElement.data('gfrow').getRowCSS();
            }
            const screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
            history = {
              id: item.id,
              action: 'design-option',
              style: style,
              screenType: screenType,
              extra: item.extra,
            };
            if (type === 'undo' && item?.extra?.targetClass) {
              const removeClasses = item?.extra?.removeClasses || [];
              $gryffBody.find(item.extra.targetClass).removeClass(removeClasses.join(' '));
              this.$gfLeftSideBar.find(`input[name="${item.extra.inputId}"]`).removeAttr(SPACING_DATA_KEY);
              emitter.emit('gsChangeHistoryForTabDS');
            }
          }, 5);
          break;
        case 'repeator':
          var capture = false;
          var $mdSettings = $gfLeftSideBar.find('#md-settings.active');
          if ($targetElement && ($mdSettings.length == 0 || $mdSettings.data('edittingID') != item.id)) {
            if ($targetElement.data('gfelement') != undefined) {
              $targetElement.data('gfelement').openElementSettings('Design', undefined, capture);
            } else if ($targetElement.data('gfmodule') != undefined) {
              $targetElement.data('gfmodule').openModuleSettings('Design', undefined, capture);
            } else if ($targetElement.data('gfrow') != undefined) {
              $targetElement.data('gfrow').openRowSettings('Design', undefined, capture);
            }
            setTimeout(function () {
              $mdSettings = $gfLeftSideBar.find('#md-settings.active');
            }, 3);
          }
          setTimeout(function () {
            let jsonData = '';
            let childData = {};
            if ($targetElement.data('gfmodule') != undefined) {
              if ($targetElement.attr('data-label') != '(P) Swatches') {
                const $repeator = $mdSettings.find('.repeator');
                if ($repeator.data('gfrepeator') != undefined) {
                  jsonData = $repeator.data('gfrepeator').getJsonData();

                  var currentData = jsonData;
                  var currentItems = currentData.items;
                  var itemData = jQuery.parseJSON(item.extra.items);
                  var items = itemData.items;

                  //repeator remove
                  if (currentItems.length > items.length) {
                    var itemRemove;
                    for (var h = 0; h < currentItems.length; h++) {
                      for (var k = 0; k < items.length; k++) {
                        if (JSON.stringify(items[k]) != JSON.stringify(currentItems[h])) {
                          itemRemove = currentItems[h];
                        }
                      }
                    }
                    var $html = jQuery('<div />').html(itemRemove.content);
                    var html = '';
                    var bkHtml = '';
                    var data = {};

                    $html.children('div').each(function () {
                      const merChildId = jQuery(this).attr('id');
                      const $merChild = $targetElement.find('#' + merChildId);

                      if ($merChild.data('gfrow') != undefined) {
                        data = $merChild.data('gfrow').export('clone');
                      } else if ($merChild.data('gfmodule') != undefined) {
                        data = $merChild.data('gfmodule').export('clone');
                      } else if ($merChild.data('gfelement') != undefined) {
                        data = $merChild.data('gfelement').export('clone');
                      }

                      html += data.html;
                      bkHtml += data.bkHtml;
                    });
                    childData = {
                      html: html,
                      bkHtml: bkHtml,
                    };
                  }

                  jsonData = JSON.stringify(jsonData);
                }
              } else {
                const $swatcher = $mdSettings.find('#swatcher');
                if ($swatcher.data('gfswatcher') != undefined) {
                  jsonData = $swatcher.data('gfswatcher').getJsonData();
                }
              }

              history = {
                id: item.id,
                action: 'repeator',
                extra: {
                  items: jsonData,
                  childData: childData,
                },
              };
            } else if ($targetElement.data('gfelement') != undefined) {
              const $divSettings = $mdSettings.children();
              switch ($divSettings.attr('id')) {
                case 'md-dropdown':
                  var $dropdown = $divSettings.find('[name="options"]');
                  if ($dropdown && $dropdown.data('gfoptions') != undefined) {
                    jsonData = $dropdown.data('gfoptions').getJsonData();
                    var currentData = jsonData;
                    var currentItems = currentData.items;
                    var itemData = jQuery.parseJSON(item.extra.items);
                    var items = itemData.items;

                    //repeator remove
                    if (currentItems.length > items.length) {
                      var itemRemove;
                      for (var h = 0; h < currentItems.length; h++) {
                        for (var k = 0; k < items.length; k++) {
                          if (JSON.stringify(items[k]) != JSON.stringify(currentItems[h])) {
                            itemRemove = currentItems[h];
                          }
                        }
                      }
                      var $html = jQuery('<div />').html(itemRemove.content);
                      var html = '';
                      var bkHtml = '';
                      var data = {};

                      $html.children('div').each(function () {
                        const merChildId = jQuery(this).attr('id');
                        const $merChild = $targetElement.find('#' + merChildId);

                        if ($merChild.data('gfrow') != undefined) {
                          data = $merChild.data('gfrow').export('clone');
                        } else if ($merChild.data('gfmodule') != undefined) {
                          data = $merChild.data('gfmodule').export('clone');
                        } else if ($merChild.data('gfelement') != undefined) {
                          data = $merChild.data('gfelement').export('clone');
                        }

                        html += data.html;
                        bkHtml += data.bkHtml;
                      });
                      childData = {
                        html: html,
                        bkHtml: bkHtml,
                      };
                    }

                    jsonData = JSON.stringify(jsonData);
                  }
                  break;
              }

              history = {
                id: item.id,
                action: 'repeator',
                extra: {
                  items: jsonData,
                  childData: childData,
                },
              };
            }
          }, 5);
          break;
        case 'text-edit':
          if ($targetElement.length > 0) {
            const html = $targetElement.find('.text-edit').html();
            history = {
              id: item.id,
              action: 'text-edit',
              html: html,
            };
          }
          break;
        case 'editor':
          if ($targetElement.length > 0) {
            switch (item.extra.edit) {
              case 'code':
                var extra = {
                  edit: 'code',
                };
                if (item.extra.style) {
                  var style = '';
                  var colId = null;
                  if ($targetElement.data('gfmodule') != undefined) {
                    style = $targetElement.data('gfmodule').getModuleCSS();
                  } else if ($targetElement.data('gfelement') != undefined) {
                    style = $targetElement.data('gfelement').getElementCSS();
                  } else if ($targetElement.data('gfrow') != undefined) {
                    style = $targetElement.data('gfrow').getRowCSS();
                  } else if ($targetElement.hasClass('gf_column')) {
                    colId = $targetElement.attr('data-id');
                    style = $targetElement.parent().data('gfrow').getColCSS(colId);

                    $targetElement = $targetElemen.parent(); // ?? :D ?? sao code van chay
                  } else {
                    if ($targetElement.closest('.element-wrap').length > 0) {
                      if ($targetElement.closest('.element-wrap').data('gfelement') != undefined) {
                        style = $targetElement.closest('.element-wrap').data('gfelement').getElementCSS();

                        $targetElement = $targetElement.closest('.element-wrap');
                      }
                    } else if ($targetElement.closest('.module-wrap').length > 0) {
                      if ($targetElement.closest('.module-wrap').data('gfmodule') != undefined) {
                        style = $targetElement.closest('.module-wrap').data('gfmodule').getModuleCSS();

                        $targetElement = $targetElement.closest('.module-wrap');
                      }
                    }
                  }

                  if (colId) {
                    extra.target = 'col';
                    extra.style = style;
                    extra.colId = colId;
                  } else {
                    extra.style = style;
                  }
                }
                if (item.extra.template) {
                  var template = '';
                  if ($targetElement.data('gfmodule') != undefined) {
                    template = $targetElement.data('gfmodule').getModuleTemplate();
                  } else if ($targetElement.data('gfelement') != undefined) {
                    template = $targetElement.data('gfelement').getElementTemplate();
                  }
                  extra.template = template;
                }
                if (item.extra.script) {
                  var script = '';
                  if ($targetElement.data('gfmodule') != undefined) {
                    script = $targetElement.data('gfmodule').getModuleScript();
                  }
                  extra.script = script;
                }
                if (item.extra.data) {
                  var data = '';
                  if ($targetElement.data('gfmodule') != undefined) {
                    data = $targetElement.data('gfmodule').getModuleData();
                  }
                  extra.data = data;
                }
                history = {
                  id: item.id,
                  action: 'editor',
                  extra: extra,
                };
                break;
              case 'css':
                var style = '';
                var colId = null;
                if ($targetElement.data('gfmodule') != undefined) {
                  style = $targetElement.data('gfmodule').getModuleCSS();
                } else if ($targetElement.data('gfelement') != undefined) {
                  style = $targetElement.data('gfelement').getElementCSS();
                } else if ($targetElement.data('gfrow') != undefined) {
                  style = $targetElement.data('gfrow').getRowCSS();
                } else if ($targetElement.hasClass('gf_column')) {
                  colId = $targetElement.attr('data-id');
                  style = $targetElement.parent().data('gfrow').getColCSS(colId);

                  $targetElement = $targetElemen.parent();
                } else {
                  if ($targetElement.closest('.element-wrap').length > 0) {
                    if ($targetElement.closest('.element-wrap').data('gfelement') != undefined) {
                      style = $targetElement.closest('.element-wrap').data('gfelement').getElementCSS();

                      $targetElement = $targetElement.closest('.element-wrap');
                    }
                  } else if ($targetElement.closest('.module-wrap').length > 0) {
                    if ($targetElement.closest('.module-wrap').data('gfmodule') != undefined) {
                      style = $targetElement.closest('.module-wrap').data('gfmodule').getModuleCSS();

                      $targetElement = $targetElement.closest('.module-wrap');
                    }
                  }
                }

                if (colId) {
                  var extra = {
                    edit: 'css',
                    target: 'col',
                    style: style,
                    colId: colId,
                  };
                } else {
                  var extra = {
                    edit: 'css',
                    style: style,
                  };
                }
                history = {
                  id: item.id,
                  action: 'editor',
                  extra: extra,
                };

                break;
              case 'html':
                var template = '';
                if ($targetElement.data('gfmodule') != undefined) {
                  template = $targetElement.data('gfmodule').getModuleTemplate();
                } else if ($targetElement.data('gfelement') != undefined) {
                  template = $targetElement.data('gfelement').getElementTemplate();
                }

                var extra = {
                  edit: 'html',
                  template: template,
                };
                history = {
                  id: item.id,
                  action: 'editor',
                  extra: extra,
                };

                break;
              case 'script':
                var script = '';
                if ($targetElement.data('gfmodule') != undefined) {
                  script = $targetElement.data('gfmodule').getModuleScript();
                }

                var extra = {
                  edit: 'script',
                  script: script,
                };
                history = {
                  id: item.id,
                  action: 'editor',
                  extra: extra,
                };

                break;
              case 'data':
                var data = '';
                if ($targetElement.data('gfmodule') != undefined) {
                  data = $targetElement.data('gfmodule').getModuleData();
                }

                var extra = {
                  edit: 'data',
                  data: data,
                };
                history = {
                  id: item.id,
                  action: 'editor',
                  extra: extra,
                };

                break;
            }
          }
          break;
        case 'gs-history-for-tab-ds':
          let addClasses = item.extra.addClasses.join(' ');
          if (type === 'undo') {
            addClasses = item.extra.prevClasses.join(' ');
            _redo.push(item);
          }
          const removeClasses = item?.extra?.removeClasses || [];
          $gryffBody.find(item.extra.targetClass).removeClass(removeClasses.join(' '));
          $gryffBody.find(item.extra.targetClass).addClass(addClasses);
          emitter.emit('gsChangeHistoryForTabDS');
          break;
      }

      // Item tương ứng đã bị pop ra khỏi mảng undo hoặc redo trước đó
      // Với sự kiện undo sẽ push item mới vào _redo
      // Với sự kiện redo sẽ push item mới vào _undo
      setTimeout(function () {
        if (!jQuery.isEmptyObject(history)) {
          if (type == 'undo') {
            const lastRedo = _this.getLastRedo();
            // Kiểm tra xem có bị push nhiều lần giống nhau không.
            if (JSON.stringify(history) != JSON.stringify(lastRedo)) {
              _redo.push(history);
              _countAddUndo = 0;
            }
          } else {
            const lastHistory = _this.getLastHistory();
            // Kiểm tra xem có bị push nhiều lần giống nhau không.
            if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
              _undo.push(history);
            }
          }
        }
        _this.checkUndoAndRedo();
      }, 8);
    };

    this.addHistory = function (type, merId, extra) {
      if (extra == undefined) {
        extra = {};
      }

      switch (type) {
        case 'column-chooser':
          var history = {
            id: 'r-' + merId,
            action: 'column-chooser',
            extra: extra,
          };

          _undo.push(history);

          break;
        case 'tabs':
          var history = {
            id: merId,
            action: 'tabs',
            index: extra,
          };
          _undo.push(history);
          // add to redo
          if (_redo.length > 0) {
            const lastRedo = _this.getLastRedo();
            if (lastRedo.action != 'tabs') {
              _redo.push(history);
            }
          }

          break;
        case 'setting':
          if (extra.flagBKSettings) {
            var options = jQuery.parseJSON(JSON.stringify(_merOldBackupSettings));
          } else {
            var options = jQuery.parseJSON(JSON.stringify(_merOldSettings));
          }

          var screenType =
            $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
          var history = {
            id: merId,
            action: 'setting',
            options: options,
            screenType: screenType,
            extra: extra,
          };
          var lastHistory = _this.getLastHistory();

          // Kiểm tra xem có bị push nhiều lần giống nhau không.
          if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
            _undo.push(history);
            store.setValue('__isSaved', false);
            _this.checkStack();
          }
          break;
        case 'field-setting':
          if (!extra.screenType) {
            var screenType =
              $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
          } else {
            var screenType = extra.screenType;
          }
          var history = {
            id: merId,
            action: 'field-setting',
            screenType: screenType,
            extra: extra,
          };

          var lastHistory = _this.getLastHistory();

          // Kiểm tra xem có bị push nhiều lần giống nhau không.
          if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
            _undo.push(history);
            store.setValue('__isSaved', false);
            _this.checkStack();
          }
          break;
        case 'design-option':
          if (extra.flagBKDesignOptions) {
            var style = _merOldBackupDesignOptions;
          } else {
            var style = _merOldDesignOptions;
          }

          var screenType =
            $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
          var history = {
            id: merId,
            action: 'design-option',
            style: style,
            screenType: screenType,
            extra: extra,
          };

          var lastHistory = _this.getLastHistory();

          // Kiểm tra xem có bị push nhiều lần giống nhau không.
          if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
            // Kiểm tra xem có đúng CSS không?
            if (history.style && history.style.indexOf && history.style.indexOf('#' + merId) >= 0) {
              _undo.push(history);
              store.setValue('__isSaved', false);
              _this.checkStack();
            }
          }
          break;
        case 'repeator':
          var history = {
            id: merId,
            action: 'repeator',
            extra: extra,
          };

          var lastHistory = _this.getLastHistory();
          // Kiểm tra xem có bị push nhiều lần giống nhau không.
          if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
            _undo.push(history);
            store.setValue('__isSaved', false);
            _this.checkStack();
          }
          break;
        case 'add':
        case 'delete':
          var lastHistory = _this.getLastHistory();
          // Kiểm tra xem có bị push nhiều lần giống nhau không.
          if (JSON.stringify(extra) != JSON.stringify(lastHistory)) {
            _undo.push(extra);
            store.setValue('__isSaved', false);
            _this.checkStack();
          }
          break;
        case 'move':
          var lastHistory = _this.getLastHistory();
          // Kiểm tra xem có bị push nhiều lần giống nhau không và có cut và paste không.
          if (JSON.stringify(extra) != JSON.stringify(lastHistory)) {
            _undo.push(extra);
            if (extra && extra.events && extra.events.length >= 2) {
              store.setValue('__isSaved', false);
              _this.checkStack();
            }
          }
          break;
        case 'text-edit':
          var $targetElement = $gryffBody.find('#' + merId);
          if ($targetElement.length > 0) {
            if (extra && extra.cacheHtml) {
              var html = extra.cacheHtml;
            } else {
              var html = $targetElement.find('.text-edit').html();
            }

            var history = {
              id: merId,
              action: 'text-edit',
              html: html,
            };

            var lastHistory = _this.getLastHistory();
            // Kiểm tra xem có bị push nhiều lần giống nhau không.
            if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
              _undo.push(history);
              store.setValue('__isSaved', false);
              _this.checkStack();
            }
          }
          break;
        case 'editor':
          var history = {
            id: merId,
            action: 'editor',
            extra: extra,
          };

          var lastHistory = _this.getLastHistory();
          // Kiểm tra xem có bị push nhiều lần giống nhau không.
          if (JSON.stringify(history) != JSON.stringify(lastHistory)) {
            _undo.push(history);
            store.setValue('__isSaved', false);
            _this.checkStack();
          }
          break;
        case 'gs-history-for-tab-ds':
          var history = {
            id: merId,
            action: type,
            screenType: screenType,
            extra: extra,
          };
          _undo.push(history);
          store.setValue('__isSaved', false);
          break;
      }

      _this.checkUndoAndRedo();
      return false;
    };

    this.checkStack = function () {
      let count = 0;
      for (let i = 0; i < _undo.length; i++) {
        if (_undo[i].action != 'tabs') {
          count++;
        }
      }
      if (count > 20) {
        while (true) {
          const cut = _undo.shift();
          if (cut.action != 'tabs') {
            break;
          }
        }
      }
      // Reset undo nếu người dùng làm việc quá 5 lần.
      if (_redo.length > 0) {
        if (_countAddUndo >= 5) {
          _redo = [];
          _countAddUndo = 0;
        } else {
          _countAddUndo++;
        }
      }
      return false;
    };

    this.updateMERSettings = function (option) {
      for (let i = 0; i < _merOldSettings.length; i++) {
        if (_merOldSettings[i].name == option.name) {
          _merOldSettings[i] = option;
        }
      }
      return false;
    };

    this.captureMERSettings = function () {
      const $mdSettings = $gfLeftSideBar.find('#md-settings');

      _merOldSettings = [];
      $mdSettings
        .find('.settings-panel, .general-panel')
        .find('input, select, textarea')
        .each(function () {
          if (jQuery(this).attr('name') != undefined) {
            const option = {
              name: jQuery(this).attr('name') != undefined ? jQuery(this).attr('name') : '',
              id: jQuery(this).attr('id') != undefined ? jQuery(this).attr('id') : '',
              value: jQuery(this).attr('value'),
            };
            _merOldSettings.push(option);
          }
        });

      const merId = $mdSettings.data('edittingID');
      const $mer = $gryffBody.find('#' + merId);

      let style = '';
      if ($mer.data('gfelement') != undefined) {
        style = $mer.data('gfelement').getElementCSS();
      } else if ($mer.data('gfmodule') != undefined) {
        style = $mer.data('gfmodule').getModuleCSS();
      } else if ($mer.data('gfrow') != undefined) {
        style = $mer.data('gfrow').getRowCSS();
      }
      _merOldDesignOptions = style;

      return false;
    };

    this.setMERBackupSettings = function () {
      _merOldBackupSettings = _merOldSettings;

      return _merOldBackupSettings;
    };

    this.setMERBackupDesignOptions = function () {
      _merOldBackupDesignOptions = _merOldDesignOptions;

      return _merOldBackupDesignOptions;
    };

    this.getLastHistory = function () {
      const history = {};
      if (_undo.length > 0) {
        try {
          return jQuery.parseJSON(JSON.stringify(_undo[_undo.length - 1]));
        } catch (error) {
          console.log(error);
        }
      }
      return history;
    };

    this.getLastRedo = function () {
      const history = {};
      if (_redo.length > 0) {
        try {
          return jQuery.parseJSON(JSON.stringify(_redo[_redo.length - 1]));
        } catch (error) {
          console.log(error);
        }
      }
      return history;
    };

    this.removeLastHistory = function () {
      if (_undo.length > 0) {
        _undo.pop();
      }
      return true;
    };

    this.getPosition = function ($itemContent, $targetElement) {
      if ($targetElement != undefined) {
        const $currentTargetElement = $gryffBody.find('#' + $targetElement.attr('id'));

        let $parent = $currentTargetElement.closest('.gf_row, .module-wrap, .element-wrap');
        if ($parent.attr('id') == $currentTargetElement.attr('id')) {
          $parent = $parent.parent().closest('.gf_row, .module-wrap, .element-wrap');
        }

        const parentId = $parent.length > 0 ? $parent.attr('id') : '';

        let $before = $currentTargetElement.prev();
        while (
          (
            $before.attr('class') == undefined &&
            $before[0] &&
            ($before[0].tagName == 'SCRIPT' || $before.attr('style') == 'display:none!important')
          ) || (
            $before.attr('class') != undefined &&
            !$before.hasClass('gf_row') &&
            !$before.hasClass('module-wrap') &&
            !$before.hasClass('element-wrap')
          )
        ) {
          $before = $before.prev();
        }

        const beforeId = $before.length > 0 ? $before.attr('id') : '';
        let index;
        if ($currentTargetElement.parent().hasClass('gf_column')) {
          var $itemContent = $currentTargetElement.parent();
          if ($parent.length > 0) {
            $parent.children('.gf_column').each(function (indexColumn) {
              if (jQuery(this).attr('id') == $itemContent.attr('id')) {
                index = indexColumn + 1;
              }
            });
          } else {
            index = $itemContent.index() + 1;
          }
        } else {
          var $itemContent = $currentTargetElement.closest('.item-content');
          index = $itemContent.data('index') != undefined ? $itemContent.data('index') : 1;
        }
        const key = $itemContent.data('key') != undefined ? $itemContent.data('key') : 'content';

        const position = {
          inside: parentId,
          after: beforeId,
          index: index,
          key: key,
        };
        return position;
      } else {
        return {
          inside: '',
          after: '',
          index: 1,
          key: 'content',
        };
      }
    };

    this.updateScroll = function () {
      if (_item) {
        const $targetElement = $gryffBody.find('#' + _item.id);
        if ($targetElement.length > 0) {
          const scrollTop = $targetElement.offset().top;

          const viewPortTop = $gfFrame.contents().find('html').scrollTop();
          const viewPortBottom = viewPortTop + window.innerHeight;

          // Elm Hiện tại nằm ngoài viewport;
          if (scrollTop < viewPortTop || scrollTop > viewPortBottom) {
            const top = scrollTop - (window.innerHeight - 50) / 3;
            $gfFrame.contents().find('html').animate(
              {
                scrollTop: top,
              },
              400,
            );
          }
        }
      }
    };

    this.init();
  };
  jQuery.fn.gfHistory = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfhistory')) {
        const plugin = new jQuery.gfHistory(this, options);
        jQuery(this).data('gfhistory', plugin);
      }
    });
  };
})(jQuery);
